import { useTranslation } from '@/hooks/useTranslation';
import { toTitleCase } from '@utils/textCase';
import type { EnvelopeStatus } from '@workpay/ds-shared/types/envelope';
import styles from './EnvelopeStatusBadge.module.scss';

function badgeClass(status: EnvelopeStatus): string {
  switch (status) {
    case 'COMPLETED':
    case 'REVIEW_COMPLETED':
      return styles.badgeSuccess ?? '';
    case 'DRAFT':
      return styles.badgeNeutral ?? '';
    case 'VOIDED':
    case 'DECLINED':
    case 'EXPIRED':
      return styles.badgeDanger ?? '';
    case 'SENT':
    case 'VIEWED':
    case 'PENDING_REVIEW':
    case 'UNDER_NEGOTIATION':
    case 'REVISED':
    case 'SIGNING_IN_PROGRESS':
      return styles.badgeInfo ?? '';
  }
}

function EnvelopeStatusBadge({ status }: { status: EnvelopeStatus }) {
  const { t } = useTranslation();
  const label = toTitleCase(
    t(`K_ENVELOPE_STATUS_${status}`, status.replace(/_/g, ' ')),
  );
  return <span className={`${styles.badge} ${badgeClass(status)}`}>{label}</span>;
}

export default EnvelopeStatusBadge;
